import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProducer(agro_exporter_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/edit_inspection/${agro_exporter_id}/crop_field`
    );
  },
  fetchCropField(agro_exporter_id, crop_field_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/list_templates/${agro_exporter_id}/crop_field/${crop_field_id}`
    );
  },
  fetchTemplate({ agro_exporter_id, crop_field_id, quality_template_id }) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/edit_inspection/${agro_exporter_id}/${crop_field_id}/quality_template/${quality_template_id}`
    );
  },
  fetchInspectors(agro_exporter_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/edit_inspection/${agro_exporter_id}/fetch_inspectors`
    );
  },
  fetchExportQualityInspect({agro_exporter_id, crop_field_id, quality_template_id, quality_inspect_id }) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/edit_inspection/${agro_exporter_id}/${crop_field_id}/${quality_template_id}/quality_inspect/${quality_inspect_id}`
    );
  },
  updateExportQualityInspect({
    agro_exporter_id,
    quality_inspect_id,
    registered_at,
    observations,
    samplings,
    inspect_code,
    inspector_id,
    quality_samplings
  }) {
    return RequesterV1.post(
      `/agro_exporter/quality_control/crop_field/edit_inspection/${agro_exporter_id}/quality_inspect/${quality_inspect_id}/update`,
      {
        quality_inspect: {
          registered_at,
          samplings,
          inspect_code,
          inspector_id,
          observations
        },
        quality_samplings
      }
    );
  },
  updateWithoutSamplings({
    agro_exporter_id,
    quality_inspect_id,
    registered_at,
    observations,
    inspect_code,
    inspector_id,
    quality_generals
  }) {
    return RequesterV1.post(
      `/agro_exporter/quality_control/crop_field/edit_inspection/${agro_exporter_id}/quality_inspect/${quality_inspect_id}/update_without_samplings`,
      {
        quality_inspect: {
          registered_at,
          inspect_code,
          inspector_id,
          observations
        },
        quality_generals
      }
    );
  }
};
